<template>
  <div>
    <!-- 查看详情 -->
    <el-dialog
      :visible="dialogVisible"
      @close="handleClose"
      center
      top="10px"
      append-to-body
    >
      <div class="info">
        <h2>停车场信息</h2>
        <el-row>
          <el-col :span="12">
            <p><span>停车场名称：</span>{{tempOrder.name}}</p>
            <p><span>泊位号：</span>{{tempOrder.parkSpotNumber}}</p>
          </el-col>
          <el-col :span="12">
            <p><span>入口名称：</span>{{tempOrder.entranceName}}</p>
            <p><span>出口名称：</span>{{tempOrder.exitName}}</p>
          </el-col>
        </el-row>
      </div>
      <el-divider></el-divider>
      <div class="info">
        <h2>车辆信息</h2>
        <el-row>
          <el-col :span="12">
            <p><span>车牌号：</span>{{tempOrder.plateNumber}}</p>
            <p><span>车牌颜色：</span>{{plateColorOptions[tempOrder.plateColor]}}</p>
          </el-col>
          <el-col :span="12">
            <p><span>车辆类型：</span>{{carSize}}</p>
          </el-col>
        </el-row>
      </div>
      <el-divider></el-divider>
      <div class="info">
        <h2>订单信息</h2>
        <el-row>
          <el-col :span="12">
            <p><span>订单号：</span>{{tempOrder.orderId}}</p>
            <p><span>订单状态：</span>{{tempOrder.orderStatus}}</p>
            <p><span>入场时间：</span>{{tempOrder.cameAt}}</p>
            <p><span>出场时间：</span>{{tempOrder.leftAt}}</p>
            <p><span>停车状态：</span>{{tempOrder.parkStatus}}</p>
            <p><span>停车时长：</span>{{tempOrder.parkingLength}}</p>
          </el-col>
          <el-col :span="12">
            <p><span>订单金额：</span>{{(tempOrder.payableAmount||tempOrder.payableAmount===0) ? (tempOrder.payableAmount + '元') : '---'}}</p>
            <p><span>实付金额：</span>{{(tempOrder.moneyValuePaid||tempOrder.moneyValuePaid===0) ? (tempOrder.moneyValuePaid + '元') : '---'}}</p>
            <p><span>优惠券金额：</span>{{tempOrder.couponMoney}}</p>
            <p><span>支付状态：</span>{{tempOrder.payStatus?'已支付':'未支付'}}</p>
            <p><span>支付时间：</span>{{tempOrder.paidAt}}</p>
            <p><span>支付方式：</span>{{tempOrder.remark}}</p>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="img-list" v-if="tempOrder.images&&tempOrder.images.length">
              <span>停车图片：</span>
              <div class="img-box">
                <div class="single-img" v-for="(item, idx) in tempOrder.images" :key="idx">
                  <el-image
                    class="img"
                    lazy
                    :src="item.url"
                    fit="fill"
                    :preview-src-list="item.urlArr"
                  >
                    <div slot="placeholder" class="image-slot">
                      加载中<span class="dot">...</span>
                    </div>
                    <div slot="error" class="image-slot">
                      暂无图片
                    </div>
                  </el-image>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getOrder, billCarSize } from "@/api/module/tenant";
import parkMix from "@/minxs/parkLotId";
import showdialog from "@/minxs/showdialog";

export default {
  props: {
    orderId: {
      type: Number,
      default: -1
    },
  },
  data() {
    return {
      tempOrder: {},
      detailDialogFormVisible: false,
      plateColorOptions: ['未知', '蓝色', '黄色', '白色', '黑色', '绿色', '新能源'],
      carSizeTable: [],
      tableData: [],
      loading: false,
    }
  },
  mixins: [parkMix, showdialog],
  mounted() {
    this.handleLookup();
  },
  computed: {
    carSize: function () {
      let arr = this.carSizeTable.filter(v => {
        return v.Id === this.tempOrder.carSize
      });
      if (arr.length === 0) arr[0]= {Name: '不区分'};
      return arr[0].Name
    }
  },
  methods: {
    // 查看详情
    handleLookup() {
      getOrder({ Id: Number(this.orderId) }).then((res) => {
        if (res.state === "success") {
          this.tempOrder = res.data;
          let arr = this.tempOrder.images.map(v =>{
            v = v.indexOf('https') === -1 ? v.replace('http','https') : v;
            return {
              url: v,
              urlArr: [v]
            }
          });
          this.tempOrder.images = arr;
          this.detailDialogFormVisible = true;
          this.getCarSize();
        }
      });
    },
    async getCarSize() {
      let res = await billCarSize();
      if (res.state === "success") {
        this.carSizeTable = res.data
        // console.log(res)
      } else {
        this.$message.error(res.message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.info {
  margin: 20px 0;
  h2 {
    margin: 12px 0;
  }
  p {
    margin: 5px 0;
    span {
      display: inline-block;
      width: 100px;
      text-align: right;
      margin: 0 15px;
    }
  }
}
.img-list{
  span {
    display: inline-block;
    width: 100px;
    text-align: right;
    margin: 0 15px;
  }
}
.single-img{
  margin: 10px 130px;
  width: 130px;
  height: 82px;
  img{
    width: 100%;
    height: 100%;
  }
}
</style>
